
import { motion } from "framer-motion";
import { AuthForm } from "@/components/auth/AuthForm";
import HeaderWithPWA from "@/components/layout/HeaderWithPWA";

const Auth = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <HeaderWithPWA />
      
      <main className="flex-1 pt-20">
        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-center">
              <motion.div 
                className="flex-1"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
              >
                <h1 className="text-4xl font-bold mb-4">
                  Welcome to Grade Test Pro
                </h1>
                <p className="text-xl text-muted-foreground mb-6">
                  Sign in or create an account to start practicing for your provincial tests
                </p>
                
                <div className="glass-card p-6 rounded-xl bg-blue-100/40 mb-8">
                  <h3 className="text-lg font-medium mb-2">Why create an account?</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Track your progress over time
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Save your test results
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Get personalized recommendations
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 text-primary">•</span>
                      Access from any device
                    </li>
                  </ul>
                </div>
              </motion.div>
              
              <motion.div 
                className="flex-1 w-full max-w-md"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <AuthForm />
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      
      <footer className="bg-secondary/50 py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-muted-foreground">&copy; 2025 Grade Test Pro. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Auth;
